import { render } from "./inpatient_index.vue?vue&type=template&id=224dc23c&scoped=true"
import script from "./inpatient_index.vue?vue&type=script&lang=js"
export * from "./inpatient_index.vue?vue&type=script&lang=js"

import "./inpatient_index.vue?vue&type=style&index=0&id=224dc23c&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224dc23c"]])

export default __exports__